const initState = {
    cart: [],
    menu: {
        mobile_menu_opened: false,
    },
    searching: {
        focused: false,
        result: [],
    },
    product_page: {
        product_page_opened: false,
        product_data: '',
    },
    popups: {
        contact_form_opened: false,
        consultation_form_opened: false,
        change_caterories_opened: false,
        add_new_product: {
            opened: false,
            category: '',
        },
        change_product: {
            opened: false,
            data: {},
        },
    },
    order_form_data: {
        incoming_data: '',
        order_type: ''
    }
}

export const cartReducer = ( state = initState.cart, action ) => {
    const newList = [];
    switch (action.type) {
        case 'ADD_TO_CART':
            return state = [...state, action.value]
        case 'REMOVE_FROM_CART':
            console.log('removed');
            state.map( (el,id) => {
                if ( id !== action.value ) {
                    newList.push(el)
                }
                return 'ok'
            })
            return state = newList
        case 'CHANGE_PRODUCT_COUNT_IN_CART':
            console.log('changed');
            state.map( (product,index) => {
                if ( index === action.index ) {
                    const changed_product = {...product, count: action.count}                    
                    newList.push(changed_product)
                } else (
                    newList.push(product)
                )
                return 'ok'
            })
            
            return state = newList
        case 'CLEAN_CART':
            return state = []
        default:
            return state
    }
}

export const searchingReducer = ( state = initState.searching, action ) => {
    switch (action.type) {
        case 'SEARCHING_BAR_FOCUSED':
            return state = {...state, focused: true}
        case 'SEARCHING_BAR_BLURED':
            return state = {...state, focused: false}
        case 'SET_SEARCHING_RESULT':
            return state = {...state, result: action.result }
        default:
            return state
    }
}

export const menuReducer = ( state = initState.menu, action ) => {
    switch (action.type) {
        case 'MOBILE_MENU_CLOSED':
            return state = { ...state, mobile_menu_opened: false };
        case 'MOBILE_MENU_OPENED':
            return state = { ...state, mobile_menu_opened: true };
        default:
            return state
    }
}

export const productPageReducer = ( state = initState.product_page, action ) => {
    switch (action.type) {
        case 'PRODUCT_PAGE_CLOSED':
            return state = { ...state, product_page_opened: false };
        case 'PRODUCT_PAGE_OPENED':
            return state = { ...state, product_page_opened: true };
        case 'PRODUCT_PAGE_SET_PRODUCT':
            return state = { ...state, product_data: action.product_data };
        default:
            return state
    }
}

export const popupsReducer = ( state = initState.popups, action ) => {
    switch (action.type) {
        case 'CONTACT_FORM_OPENED':
            return state = { ...state, contact_form_opened: true };
        case 'CONTACT_FORM_CLOSED':
            return state = { ...state, contact_form_opened: false };

        case 'CONSULTATION_FORM_OPENED':
            return state = { ...state, consultation_form_opened: true };
        case 'CONSULTATION_FORM_CLOSED':
            return state = { ...state, consultation_form_opened: false };

        case 'CHANGE_CATEGORIES_OPENED':
            return state = { ...state, change_caterories_opened: true };
        case 'CHANGE_CATEGORIES_CLOSED':
            return state = { ...state, change_caterories_opened: false };

        default:
            return state
    }
}

export const orderFormReducer = ( state = initState.order_form_data, action ) => {
    switch (action.type) {
        case 'SET_INCOMING_ORDER_DATA':
            return state = { incoming_data: action.value, order_type: action.order_type };
        default:
            return state
    }
}

export const addProductReducer = ( state = initState.popups.add_new_product, action ) => {
    switch (action.type) {

        case 'ADD_NEW_PRODUCT_OPENED':
            return state = { opened: true, category: action.value };
        case 'ADD_NEW_PRODUCT_CLOSED':
            return state = { opened: false, category: '' };

        default:
            return state
    }
}

export const changeProductReducer = ( state = initState.popups.change_product, action ) => {
    switch (action.type) {
        case 'CHANGE_PRODUCT_OPENED':
            return state = { opened: true, data: action.data };
        case 'CHANGE_PRODUCT_CLOSED':
            return state = { opened: false, data: {} };
        default:
            return state
    }
}

